// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGalleryInfoCard__container-fc329f {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  flex: 1;
}

.MediaGalleryInfoCard__info-a130c4 {
  overflow: hidden;
  max-width: 330px;
  margin-inline-start: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

.MediaGalleryInfoCard__title-cbbee2 {
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--addition-50);
}

.MediaGalleryInfoCard__title-cbbee2:hover,
.MediaGalleryInfoCard__title-cbbee2:active {
  text-decoration: underline;
}

.MediaGalleryInfoCard__container-fc329f:focus-visible .MediaGalleryInfoCard__title-cbbee2 {
  text-decoration: underline;
}

.MediaGalleryInfoCard__subtitle-aba97d {
  color: var(--addition-50_70);
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
}

.MediaGalleryInfoCard__title-cbbee2,
.MediaGalleryInfoCard__subtitle-aba97d {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.MediaGalleryInfoCard__subtitle-aba97d:hover,
.MediaGalleryInfoCard__subtitle-aba97d:active {
  text-decoration: underline;
}

.MediaGalleryInfoCard__avatar-fbc75a {
  width: 40px;
  height: 40px;
}

.MediaGalleryInfoCard__no-navigation-aae225,
.MediaGalleryInfoCard__no-navigation-aae225:hover,
.MediaGalleryInfoCard__no-navigation-aae225:active {
  cursor: default;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGalleryHeader/MediaGalleryInfoCard/MediaGalleryInfoCard.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,OAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,0BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,4BAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;;;EAGE,eAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  text-decoration: none;\n  cursor: pointer;\n  flex: 1;\n}\n\n.info {\n  overflow: hidden;\n  max-width: 330px;\n  margin-inline-start: 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: left;\n}\n\n.title {\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--addition-50);\n}\n\n.title:hover,\n.title:active {\n  text-decoration: underline;\n}\n\n.container:focus-visible .title {\n  text-decoration: underline;\n}\n\n.subtitle {\n  color: var(--addition-50_70);\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n}\n\n.title,\n.subtitle {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subtitle:hover,\n.subtitle:active {\n  text-decoration: underline;\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n}\n\n.no-navigation,\n.no-navigation:hover,\n.no-navigation:active {\n  cursor: default;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaGalleryInfoCard__container-fc329f`,
	"info": `MediaGalleryInfoCard__info-a130c4`,
	"title": `MediaGalleryInfoCard__title-cbbee2`,
	"subtitle": `MediaGalleryInfoCard__subtitle-aba97d`,
	"avatar": `MediaGalleryInfoCard__avatar-fbc75a`,
	"no-navigation": `MediaGalleryInfoCard__no-navigation-aae225`,
	"noNavigation": `MediaGalleryInfoCard__no-navigation-aae225`
};
module.exports = ___CSS_LOADER_EXPORT___;
